<template>
  <div>
    <div class="App">
      <div class="App__sidebar">
        <navigation />
      </div>
      <div class="App__main gray-bg">
        <top-navbar :logout="out" :change="change" />
        <router-view />
        <footer-panel />
        <nps-survey-modal />
      </div>
    </div>
    <div v-if="loading" class="overlay">
      <img src="/loading.svg" alt="Carregando..." />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { endsWith } from 'lodash'
import axios from 'axios'
import {
  setUpInterceptors,
  customResponseInterceptor,
  customRequestInterceptor
} from '../lib/interceptors'
import { getUserData, getToken } from '../lib/token'
import { mapActions } from 'vuex'

import store from '../store'
import Navigation from './Navigation'
import TopNavbar from './TopNavbar'
import FooterPanel from './FooterPanel'
import VueRouter from 'vue-router'
import NpsSurveyModal from './NpsSurveyModal'
export default {
  name: 'Layout',
  components: {
    Navigation,
    TopNavbar,
    FooterPanel,
    NpsSurveyModal
  },
  beforeRouteEnter(to, from, next) {
    setUpInterceptors()

    let refreshToken
    if (store.state.login.access_token) {
      refreshToken = store.state.login.refresh_token
      axios.defaults.headers.common[
        'Authorization'
      ] = `bearer ${store.state.login.access_token}`
    } else {
      const userData = getUserData()
      if (userData) {
        const { access_token, refresh_token } = userData
        refreshToken = refresh_token
        // eslint-disable-next-line
        axios.defaults.headers.common[
          'Authorization'
        ] = `bearer ${access_token}`

        store.dispatch('login/setUserData', userData)
      }
    }

    const str = window.localStorage.getItem('imea.portal.instituicao')

    axios.defaults.params = {}

    const locale = localStorage.getItem('locale') || 'pt-BR'
    if (locale === 'en') {
      axios.defaults.params['eng'] = true
    }

    if (str) {
      const data = JSON.parse(str)

      if (data.Id) {
        axios.defaults.params['instituicao'] = data.Id
      } else {
        axios.defaults.params['instituicao'] = ''
      }
    }

    if (from.fullPath === '/' && to.fullPath === '/dashboard') {
      new VueRouter().push('/dashboard')
      Promise.all([store.dispatch('menu/requestUserInfo')])
        .then(() => next())
        .catch(() => {
          new VueRouter().push('/login')
          next()
        })
    } else {
      store
        .dispatch('login/refreshToken', { refresh_token: refreshToken })
        .then(() => {
          return Promise.all([store.dispatch('menu/requestUserInfo')])
        })
        .then(() => next())
        .catch(() => {
          new VueRouter().push('/login')
          next()
        })
    }
  },
  created() {
    const userData = getUserData()
    const instituicaoLocalData = window.localStorage.getItem(
      'imea.portal.instituicao'
    )
    const instituicaoData =
      instituicaoLocalData && JSON.parse(instituicaoLocalData)
    const UserName = userData.Nome || ''
    const InstituicaoName = instituicaoData.Nome || ''

    // this.$analytics.setUserId(userData.userName)
    this.$analytics.setUserProperties({
      UserName,
      InstituicaoName
    })

    customRequestInterceptor(() => {
      this.loading = true
      this.reqs.push({})
    })
    customResponseInterceptor(
      () => {
        this.reqs.pop()
        this.loading = this.reqs.length !== 0
      },
      () => {
        this.reqs.pop()
        this.loading = this.reqs.length !== 0
      }
    )

    axios.interceptors.request.use(config => {
      return new Promise(resolve => {
        const { url } = config
        const store = window.vue.$store
        const { state, _actions } = store
        const { login } = state
        const { expires, refresh_token } = login
        if (!endsWith(url, '/token') && !endsWith(url, '/userinfo')) {
          if (moment().isBefore(new Date(expires))) {
            resolve(config)
          } else {
            _actions['login/refreshToken']
              [0]({ refresh_token })
              .then(token => {
                config.headers['Authorization'] = `bearer ${token}`
                return _actions['menu/requestUserInfo'][0]()
              })
              .then(() => resolve(config))
              .catch(() => {
                this.reqs.pop()
                this.loading = this.reqs.length !== 0
                config.headers['Authorization'] = `bearer ${getToken()}`
                resolve(config)
              })
          }
        } else {
          resolve(config)
        }
      })
    })

    // Personalização pro IMEA - Polichat
    if (!document.getElementById('polichat-integration')) {
      let polichatScript = document.createElement('script')
      polichatScript.setAttribute('id', 'polichat-integration')
      polichatScript.innerHTML = `!function(e,t,c,i,s,a,n){e.PolichatObject=s,e[s]=e[s]||function(){(e[s].q=e[s].q||[]).push(arguments)},a=t.createElement(c),e[s].t=e[s].t||new Date,n=t.getElementsByTagName(c)[0],a.async=1,a.src="https://ms.polichat.io/tags/public/services/serv.js",n.parentNode.insertBefore(a,n)}(window,document,"script",0,"poli"),poli("create",8735),poli("send","webchat",{uid:"14901@polichat.webchat"});`
      document.head.appendChild(polichatScript)
    }
    document.body.addEventListener('DOMSubtreeModified', () => {
      if (
        document.getElementById('plcht-container') &&
        document.getElementsByClassName('call-to-action')[0] &&
        !this.hasLoadedWidget
      ) {
        this.smoothFaleConosco()
        this.hasLoadedWidget = true
      }
    })
  },
  // Personalização pro IMEA - Polichat
  beforeRouteLeave(_, __, next) {
    const element = document.getElementById('plcht-container')
    if (element) {
      element.style.display = 'none'
    }
    next()
  },
  methods: {
    out() {
      this.logout()
      this.$router.push('/login')
    },
    change() {
      this.$router.push('/instituicao')
    },
    // Personalização pro IMEA - Polichat
    smoothFaleConosco() {
      setTimeout(() => {
        document.getElementById('plcht-container').style.display = 'block'
        setTimeout(() => {
          document.getElementsByClassName('call-to-action')[0].style.opacity = 1
        }, 1000)
        setTimeout(() => {
          document.getElementsByClassName('call-to-action')[0].style.opacity = 0
        }, 4000)
      }, 6000)
    },
    ...mapActions('login', ['logout'])
  },
  data() {
    return {
      reqs: [],
      loading: false,
      // Personalização pro IMEA - Polichat
      hasLoadedWidget: false
    }
  }
}
</script>

<style>
.App {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 220px auto;
  grid-template-rows: 1fr;
  grid-template-areas: 'sidebar main';
}

.App__sidebar {
  grid-area: sidebar;
}

.App__main {
  grid-area: main;
  display: grid;
  grid-template-rows: auto 1fr auto;
}
</style>
